export default __webpack_public_path__ + "static/media/the-playing-one.3d7d2af0.png";